module.exports = __webpack_public_path__ + "static/media/shop_2.5d85b9fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/shop_2.jpg
// module id = 489
// module chunks = 0